import {FreewallFilenamePrefix} from "@rezonence/sdk";
import {TemplateFileSuffix} from "@rezonence/core/freewall-compiler/template.file.suffix";
import {basename, extname} from "path";

const filename = `${FreewallFilenamePrefix.Ad}${TemplateFileSuffix.FormatCss}`;
const extension = extname(filename);
export const cssExtensionFilename = `${basename(filename, extension)}.ext${extension}`;
